import React from 'react';
import styled from 'styled-components';

const TextFilter: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default TextFilter;

const Container = styled.div`
  color: #3c6ab4;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.5px;
`;
